import React, { Fragment } from 'react';
import { useAuth } from '../../../contexts/AuthContext';
import UserPageStyles from '../UserPageStyles';
import { Alert, AlertTitle } from '@material-ui/lab';
import { Button, CircularProgress, Collapse, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Fab, Grid, Paper, TextField } from '@material-ui/core';
import Title from '../../../app/components/Title';
import CloseIcon from '@material-ui/icons/Close';
import GaugeTable from '../../../app/components/datatables/GaugeTables';
import { Add, HighlightOffOutlined } from '@material-ui/icons';
import { fetchAreaCode } from '../../../utils/api';
import DeleteIcon from '@material-ui/icons/Delete';
import { useData } from '../../../contexts/DataContext';
import { GridCellValue } from '@material-ui/data-grid';
import { useEffect } from 'react';

const UserRainGauges: React.FC = () => {

    const classes = UserPageStyles();
    const auth = useAuth();
    const data = useData();
    const gaugedb = data?.db?.collection('RainGauges');
    const storage = data?.storage;

    const [openAlert, setOpenAlert] = React.useState(false);
    const [alertSuccess, setAlertSuccess] = React.useState(false);
    const [alertMessage, setAlertMessage] = React.useState('');
    const [alertMessageTitle, setAlertMessageTitle] = React.useState('');
    const [disableFab, setDisableFab] = React.useState(false);
    const [latitude, setLatitude] = React.useState(0.0);
    const [longitude, setLongitude] = React.useState(0.0);
    const [address, setAddress] = React.useState('Not Available');
    const [watershedCode, setWatershedCode] = React.useState('Not Available');
    const [modalOpen, setModalOpen] = React.useState(false);
    const [disableSubmit, setDisableSubmit] = React.useState(false);
    const [fileName, setFileName] = React.useState('');
    const [image, setImage] = React.useState<File>();
    const [gaugeName, setGaugeName] = React.useState('');
    const [deleteDoc, setDeleteDoc] = React.useState('');
    const [deleteImageUrl, setDeleteImageUrl] = React.useState('');
    const [deleteModal, setDeleteModal] = React.useState(false);
    const [gaugeData, setGaugeData] = React.useState<any>([]);

    useEffect(() => {
        data?.refreshGaugeData();
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        setGaugeData(data?.gaugeData)
    }, [data?.gaugeData])

    const setAlert = (title: string, message: string, success = true) => {
        setAlertSuccess(success);
        setAlertMessage(message);
        setAlertMessageTitle(title);
        setOpenAlert(true);
    }

    const handleModalClose = () => {
        setModalOpen(false)
        setDisableSubmit(false)
        setGaugeName('')
        clearUploadedFile()
    }

    const clearUploadedFile = () => {
        setFileName('')
        setImage(undefined)
    }

    const updateGeoLocation = async () => {
        var promise = new Promise<boolean>(function (resolve, reject) {
            setTimeout(() => {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(async (position: any) => {
                        setLatitude(position.coords.latitude)
                        setLongitude(position.coords.longitude)
                        try {
                            const code = await fetchAreaCode('', position.coords.latitude, position.coords.longitude)
                            if (code.areaCode) {
                                setWatershedCode(code.areaCode)
                            } else {
                                setAlert('Location error', 'Watershed code not available for the current location.', false)
                                console.error("Location error")
                                setLatitude(0.0)
                                setLongitude(0.0)
                                reject(false)
                            }
                        } catch (err) {
                            setAlert('Location error', 'Watershed code not available for the current location.', false)
                            console.error(err)
                            setLatitude(0.0)
                            setLongitude(0.0)
                            reject(false)
                        }
                        await getReverseGeocoding(position.coords.latitude, position.coords.longitude)
                        resolve(true)
                    }, (err: any) => {
                        setAlert('GPS error', 'Please make sure that you have enabled GPS access.', false)
                        console.error(err)
                        setLatitude(0.0)
                        setLongitude(0.0)
                        reject(false)
                    });
                } else {
                    setAlert('GPS error', 'Please make sure that you have enabled GPS access.', false)
                    reject(false)
                }
            })
        })
        return promise
    }

    const getReverseGeocoding = async (lat = latitude, lon = longitude) => {
        if (lat === 0.0 || lon === 0.0)
            return 'Not Available'
        try {
            let response = await fetch('https://maps.googleapis.com/maps/api/geocode/json?latlng=' + lat + ',' + lon + '&key=AIzaSyA_hQEwXL0h9HaCPt8wDN3EuFvEw3IE-s8');
            const data = await response.json();
            const address = data?.results[2]?.formatted_address
            if (address)
                setAddress(address)
            return address
        } catch (err) {
            console.error(err);
            return 'Not Available'
        }
    }

    const handleClickAddButton = async () => {
        setDisableFab(true)
        try {
            const geoLocation = await updateGeoLocation()
            if (geoLocation) {
                setModalOpen(true)
            }
        } catch (error) {
            console.log(error);
        } finally {
            setDisableFab(false)
        }
    }

    const addData = async () => {
        setDisableSubmit(true)

        var Url = '';

        try {
            if (storage) {
                if (image) {
                    const upload = await storage.ref('gauges/' + image.name).put(image);
                    if (upload) {
                        Url = await storage.ref('gauges').child(image.name).getDownloadURL();
                    }
                    else {
                        setAlert('Error', 'Image cannot be uploaded. Please try again.', false)
                        handleModalClose();
                        return;
                    }
                }
            } else {
                setAlert('Error', 'Image cannot be uploaded. Try again later!', false)
                handleModalClose();
                return;
            }
        }
        catch {
            setAlert('Error', 'Something went wrong!', false)
            handleModalClose();
            return;
        }


        try {
            const response = await gaugedb?.add({
                "Latitude": latitude,
                "Longitude": longitude,
                "Name": gaugeName,
                "GaugeId": 'gi_' + watershedCode + "_" + new Date().getTime(),
                "Address": address,
                "WatershedCode": watershedCode,
                "Image": Url,
                "Owner": auth?.currentUser?.uid,
                "DateTime": new Date().getTime(),
                "Verified": false,
                "OwnerName": auth?.currentUser?.displayName,
                "Managers": []
            })
            if (response) {
                setAlert("Success!", 'Successfully logged data')
            }
            else {
                setAlert('Error', "Couldn't log data. Please try again.", false)
            }
        }
        catch {
            setAlert('Error', "Couldn't log data. Try again later!", false)
        }
        handleModalClose();
    }

    const deleteModalOpen = (docId: GridCellValue, docImageUrl: GridCellValue) => {
        const id = docId?.toLocaleString();
        const imageUrl = docImageUrl?.toLocaleString();
        if (id)
            setDeleteDoc(id);
        if (imageUrl)
            setDeleteImageUrl(imageUrl);
        setDeleteModal(true);
    }

    const deleteModalClose = () => {
        setDeleteModal(false);
    }

    const deleteData = async () => {
        try {
            if (deleteImageUrl) {
                if (storage) {
                    let imageRef = storage.refFromURL(deleteImageUrl);
                    imageRef.delete();
                    setAlert('Deleted', "Row Deleted Successfully");
                }
            }
            if (deleteDoc) {
                await gaugedb?.doc(deleteDoc).delete();
            }
        }
        catch {
            setAlert('Error', "Couldn't Delete Row", false);
        }
        deleteModalClose();
    }

    return (
        <Fragment>
            <Collapse in={openAlert}>
                <Alert
                    severity={alertSuccess ? "success" : "error"}
                    action={
                        <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                                setOpenAlert(false);
                            }}
                        >
                            <CloseIcon fontSize="inherit" />
                        </IconButton>
                    }
                >
                    <AlertTitle>{alertMessageTitle}</AlertTitle>
                    {alertMessage}
                </Alert>
            </Collapse>
            <Grid container>
                <Grid item xs={12}>
                    <Paper className={classes.paper} style={{ minHeight: '80vh' }}>
                        <Title>My Rain Gauges</Title>
                        <GaugeTable data={gaugeData} onCellDeleteClick={deleteModalOpen} admin={false} />
                    </Paper>
                </Grid>
            </Grid>
            {!disableFab ?
                <Fab className={classes.fab} color="primary" aria-label="add" onClick={handleClickAddButton}>
                    <Add />
                </Fab> :
                <CircularProgress className={classes.fab} />
            }
            <div>
                <Dialog fullWidth open={modalOpen} onClose={handleModalClose} aria-labelledby="form-dialog-title" >
                    <DialogTitle id="form-dialog-title">
                        Add Rain Gauge
                        <Button variant="text" style={{ float: 'right', padding: 0 }} onClick={handleModalClose}>
                            <HighlightOffOutlined />
                        </Button>
                    </DialogTitle>
                    <DialogContent>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="gauge"
                            label="Gauge Name"
                            value={gaugeName}
                            onChange={(e: any) => {
                                setGaugeName(e.target.value);
                            }}
                            fullWidth
                        />
                    </DialogContent>
                    <DialogContent>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="geoLocation"
                            label="Geo Coordinates"
                            value={latitude + "," + longitude}
                            disabled={true}
                            fullWidth
                        />
                    </DialogContent>
                    <DialogContent>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="address"
                            label="Address"
                            value={address}
                            disabled={true}
                            fullWidth
                        />
                    </DialogContent>
                    <DialogContent>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="waterShedCode"
                            label="Watershed Code"
                            value={watershedCode}
                            disabled={true}
                            fullWidth
                        />
                    </DialogContent>
                    <DialogContent>
                        <Button
                            variant="outlined"
                            component="label"
                            color="primary"
                        >
                            Add photo
                            <input
                                accept="image/*"
                                type="file"
                                hidden
                                onChange={(e: any) => {
                                    if (e.target.files[0] != null) {
                                        const newFile = new File([e.target.files[0]], `${auth?.currentUser?.uid}_${new Date().getTime()}`, { type: e.target.files[0].type })
                                        setFileName(e.target.files[0].name);
                                        setImage(newFile);
                                    }
                                }}
                                required
                            />
                        </Button> {fileName}
                        {fileName && <IconButton
                            aria-label="delete"
                            color="inherit"
                            onClick={() => {
                                clearUploadedFile()
                            }}
                        >
                            <DeleteIcon />
                        </IconButton>}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleModalClose} variant="outlined" color="default">
                            Cancel
                        </Button>
                        <Button onClick={addData} variant="contained" color="primary" disabled={!image || !gaugeName || disableSubmit}>
                            Add
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
            <div>
                <Dialog open={deleteModal} onClose={deleteModalClose} aria-labelledby="form-dialog-title">
                    <DialogContent>
                        Are you sure you want to delete this data?
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={deleteModalClose} variant="contained" color="secondary">
                            Cancel
                        </Button>
                        <Button onClick={deleteData} variant="contained" color="primary">
                            Delete
                        </Button>

                    </DialogActions>
                </Dialog>
            </div>
        </Fragment>
    );
}

export default UserRainGauges;